import React, {useEffect, useState} from 'react';
import { Tick } from '../../icons/icons';

const inputs = [
  {
    label: 'New',
    value: 'new'
  },
  {
    label: 'EOL',
    value: 'end_of_live'
  },
  {
    label: 'Active',
    value: 'active'
  },

];

const nrfndField = {
  label: 'NRFND',
    value: 'nrfnd'
};

const FilterCheckboxesStatic = ({label, name, selectedValue, nrfndValue, onCheck}) => {

  const [inputValues, setInputValues] = useState(selectedValue || [] );
  const [nrfndVal, setNrfndVal] = useState(nrfndValue || false);

  useEffect(() => {
    setInputValues(selectedValue || []);
    setNrfndVal(nrfndValue || false);
  }, [selectedValue, nrfndValue] );

  const onChangeHandler = e => {
    const value = e.target.value;
    let values = [...inputValues];

    if(inputValues.includes(value)) {
      values = values.filter((item)=> item !== value);
    } else {
      values.push(value);
    }

    setInputValues(values);
    onCheck(name, values);

  };

  const checkHandlerNRFND = () => {
    onCheck('not_recommended_fnd', !nrfndVal);
    setNrfndVal(!nrfndVal);

  };


  return (
    <div>
      <div className="product-finder-aside__toggle">
        <dl>
          <dt>{ label }</dt>
          <dd></dd>
        </dl>
      </div>
      <div className="product-finder-aside__fieldset product-finder-aside__fieldset--cols">
        { inputs.map((input, index) => (
          <div key={index} className="product-finder-aside__checkbox-group form-item">
            <input
              id={`${input.label}${index}`}
              className="form-checkbox product-finder-aside__checkbox"
              type="checkbox"
              value={input.value}
              checked={inputValues.includes(input.value)}
              onChange={onChangeHandler} />
            <label htmlFor={`${input.label}${index}`}>
              {input.label}
              <Tick/>
            </label>
          </div>
        ))}

        <div className="product-finder-aside__checkbox-group form-item">
          <input
            id={`checkbox${nrfndField.label}`}
            className="form-checkbox product-finder-aside__checkbox"
            type="checkbox"
            value={nrfndField.value}
            checked={nrfndVal}
            onClick={checkHandlerNRFND} />
          <label htmlFor={`checkbox${nrfndField.label}`}>
            {nrfndField.label}
            <Tick/>
          </label>
        </div>

      </div>
    </div>
  );
};

export default FilterCheckboxesStatic;
